// A visit as THIS patient's place in it says (blhWebServer
// docs/AVAILABILITY_MODEL_V2.md §2.8 rule 4). A visit names its participants,
// each with their own facts; on a group session one participant's place can
// end — their own cancellation — or they can be marked absent, while the
// session goes on for the others. Every screen of the portal reads the visit's
// own flags (`cancelled`, `noShow`), so each visit is read here once, as the
// patient's own: their place ended → cancelled for them, with their reason;
// marked absent → a no-show for them. A visit that does not name them, or
// names them with nothing of their own, is returned as it is.

/** The visits a patient takes part in, as the server stores them (P3): every visit naming them. */
export function participationQuery(patientId) {
  return {"participants.patientId": patientId};
}

/** One visit, as the patient's own place in it says. */
export function asSeenBy(appointment, patientId) {
  if (!appointment || !patientId || !Array.isArray(appointment.participants)) return appointment;
  const own = appointment.participants.find((record) => String(record?.patientId || "") === String(patientId));
  if (!own) return appointment;
  if (own.cancelled && !own.cancelled.withSession) {
    return {
      ...appointment,
      cancelled: true,
      cancellationReason: own.cancelled.reason || appointment.cancellationReason || null,
      cancelledAt: own.cancelled.at ?? appointment.cancelledAt ?? null,
      ownPlaceEnded: true,
    };
  }
  if (own.attendance?.attended === false) {
    return {...appointment, noShow: true, arrived: false};
  }
  return appointment;
}

/** Each visit, as the patient's own place in it says. */
export function allAsSeenBy(appointments, patientId) {
  return (appointments || []).map((appointment) => asSeenBy(appointment, patientId));
}
